import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import $ from 'jquery';
import Client from '@gate31/uikit/common/components/client/client';
import { ModalDesk } from '../ModalDesk/ModalDesk';
import { SubscribeDesk } from '../SubscribeDesk/SubscribeDesk';

export class SubscriptionModalManagerDesk {
    static readonly COOKIE_KEY_NAME = 'SUBSCRIBE_MODAL_STATUS';

    static async canShow() {
        const isIncluded = await SubscriptionModalManagerDesk.isIncluded();

        if (! isIncluded) {
            return false;
        }

        const value = $ && $.cookie ? $.cookie(SubscriptionModalManagerDesk.COOKIE_KEY_NAME) : null;

        switch (value) {
            // Не подписался и закрыл окно
            case 'CLOSED':
                return false;
            // Подписался
            case 'SUBSCRIBED':
                return false;
            // Показываем впервые
            default:
                return true;
        }
    }

    static pause() {
        $ && $.cookie ? $.cookie(
            SubscriptionModalManagerDesk.COOKIE_KEY_NAME,
            'CLOSED',
            {
                expires: 3
            }
        ) : null;
    }

    static off() {
        $ && $.cookie ? $.cookie(
            SubscriptionModalManagerDesk.COOKIE_KEY_NAME,
            'SUBSCRIBED',
            {
                expires: 999
            }
        ) : null;
    }

    static async isIncluded() {
        const { isSubscribed, isLogin } = await SubscriptionModalManagerDesk.getUserData();

        if (! isLogin) {
            return true;
        }

        if (isLogin && ! isSubscribed) {
            return window.Site.settings.subscriptionModal.withLoginWithoutSubscribtion === '1';
        }

        return false;
    }

    static async getUserData() {
        // Авторизован?
        const user = await Client.get().then(response => response.status === 'ok' ? response.client : undefined).catch(() => undefined);

        // Подписан на рассыдку?
        const isSubscribed = user?.email ?
            await Client.examinationAvailableSubscribe(user.email) :
            false;

        return {
            isSubscribed,
            isLogin: Boolean(user)
        };
    }
}

export class SubscriptionModalDesk extends BaseJs {
    static cn = new BaseJs.BuildCn('SubscriptionModalDesk');

    title: string;
    descr: string;
    photo: string;

    isSuccess: boolean

    modal: ModalDesk;
    form: SubscribeDesk | undefined;

    constructor({ template, opts }: { template: keyof LiquidTemplates; opts: { title: string; descr: string; photo: string }}) {
        super(template);

        this.title = opts.title;
        this.descr = opts.descr;
        this.photo = opts.photo;

        this.isSuccess = false;

        this.modal = this.getModal();

        this.callbackConnection();
    }

    async callbackConnection() {
        const clientStatus = await Client.get().then(response => response.status);

        if (clientStatus === 'ok') {
            SubscriptionModalManagerDesk.off();
        }

        SubscriptionModalManagerDesk.canShow().then(isShow => {
            if (isShow) {
                const delayTime = Number(window.Site.settings.modalSubscribeDelayTime) || 5;

                setTimeout(() => {
                    this.openModal();
                }, delayTime * 1000);
            }
        });

        this.modal.on('close', () => {
            if (this.isSuccess) {
                this.modal.close();
                SubscriptionModalManagerDesk.off();
                return;
            }

            SubscriptionModalManagerDesk.pause();
        });
    }

    hidePhoto() {
        const node = this.findElem<HTMLDivElement>(SubscriptionModalDesk.cn.setElem('photo').toSelector());

        if (node) {
            node.style.display = 'none';
        }
    }

    hidePhotoMode() {
        const node = this.getRoot();

        node.classList.remove(SubscriptionModalDesk.cn.setMode({ photo: true }).toString());
    }

    showPhoto() {
        const node = this.findElem(SubscriptionModalDesk.cn.setElem('photo').toSelector());

        if (node) {
            node.style.display = 'block';
        }
    }

    openModal() {
        this.modal.open(() => {
            this.form = new SubscribeDesk(this.getRoot().querySelector(SubscribeDesk.cn.toSelector()) as HTMLFormElement);

            this.form.ee.on('subscription-form:success', () => {
                this.modal.close();
                SubscriptionModalManagerDesk.off();
            });

            this.form.ee.on('subscription-form:success-message', () => {
                this.hidePhoto();
                this.hidePhotoMode();
            });
        });
    }

    getModalContent() {
        const form = LiquidRender.render(this.template, {
            is_hidden_text: 'false',
            subscription_title: this.title,
            subscription_descr: this.descr
        });

        const photo = this.photo ? `
            <div class="SubscriptionModalDesk__photo">
                <img src='${ this.photo }'>
            </div>
        ` : '';

        return `
            <div class="SubscriptionModalDesk__wrap">
                ${ photo }
                <div class="SubscriptionModalDesk__form">${ form }</div>
            </div>
        `;
    }

    getModal() {
        return new ModalDesk({
            template: 'modal-desk-template',
            content: this.getModalContent(),
            disableBodyScroll: true,
            viewOpts: {
                closeIconSize: 'm',
                className: 'SubscriptionModalDesk',
                classNameMode: this.photo ? 'photo' : ''
            }
        });
    }
}
